export const DETAILS_WRAPPER =
  "tw-pt-[24px] tw-flex tw-justify-between tw-pb-[32px]  tw-mb-[32px] tw-border-l-0 tw-border-t-0 tw-border-r-0 tw-border-b-1 tw-border-solid tw-border-neutral-gray-10";
export const DETAILS_COLUMN = "tw-w-[46.6%]";
export const DETAIL_FIELD_CONTAINER =
  "tw-relative tw-h-36px tw-w-full tw-flex tw-items-center tw-gap-12px tw-justify-between";
export const DETAIL_FIELD_VALUE_LINK = "tw-text-14d tw-font-normal tw-pr-0 tw-mr-20px tw-cursor-pointer";
